import React from "react";
import { Box, Tooltip, Typography, Divider } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const MuiTooltip = ({ message, size = "medium", sx = {} }) => {
  const renderTooltipContent = () => {
    if (Array.isArray(message)) {
      return (
        <Box sx={{ color: "#fff" }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            For a strong password it must:
          </Typography>
          {message.map((item, index) => (
            <Typography
              key={index}
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                "&:before": {
                  content: '"•"',
                  marginRight: "8px",
                },
                mb: 0.5,
              }}
            >
              {item}
            </Typography>
          ))}

          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 0.5,
              mt: 1,

            }}
          >
            *Or simply autogenerate a key!
          </Typography>
        </Box>
      );
    }
    return (
      <Typography variant="body2" sx={{ color: "#fff" }}>
        {message}
      </Typography>
    );
  };

  return (
    <Tooltip
      title={renderTooltipContent()}
      placement="right"
      arrow
      sx={{
        bgcolor: "background.paper",
        "& .MuiTooltip-tooltip": {
          maxWidth: 300,
          padding: "12px 16px",
        },
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          color: "rgba(102, 112, 133, 1)",
          borderColor: "rgba(102, 112, 133, 1)",
          width: size === "small" ? 24 : size === "large" ? 40 : 32,
          height: size === "small" ? 24 : size === "large" ? 40 : 32,
          cursor: "pointer",
          ...sx,
        }}
      >
        <InfoOutlinedIcon
          fontSize={
            size === "small" ? "small" : size === "large" ? "large" : "medium"
          }
          color="rgba(102, 112, 133, 1)"
        />
      </Box>
    </Tooltip>
  );
};

export default MuiTooltip;
